import { Stat } from '../../api';
import MonthBarChart from './MonthBarChart';

function getArrays(data: Stat, viewMode: string) {
  if (viewMode == 'transfer')
    return [
      data?.fastForward?.hls?.playlist?.bytes
        ? data.fastForward.hls.playlist.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.fastForward?.hls?.chunklist?.bytes
        ? data.fastForward.hls.chunklist.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.fastForward?.hls?.media?.bytes
        ? data.fastForward.hls.media.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
    ];
  else if (viewMode == 'notfound') return data?.fastForward?.hls?.notFound ? [data.fastForward.hls.notFound] : [[]];
  else return data?.fastForward?.hls?.playlist?.count ? [data.fastForward.hls.playlist.count] : [[]];
}
function getTitle(viewMode: string, day: number): string {
  if (viewMode == 'transfer') return `Fast Forward HLS bandwidth usage (MB) by ${day ? 'hour' : 'day'}`;
  else if (viewMode == 'notfound') return `Fast Forward HLS download fails by ${day ? 'hour' : 'day'}`;
  else return `Fast Forward HLS accesses by ${day ? 'hour' : 'day'}`;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getUnit(viewMode: string, day: number | undefined): string {
  if (viewMode == 'transfer') return 'MB';
  if (viewMode == 'notfound') return 'fails';
  return 'accesses';
}

export default function MonthCameraFastForwardHlsChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  viewMode: string;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  onChangeDay: (d: number) => void;
}) {
  return <MonthBarChart getUnit={getUnit} getTitle={getTitle} getArrays={getArrays} {...props} />;
}
